"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toRecord = void 0;
function toRecord(arr, key) {
    return arr.reduce((acc, entry) => {
        const k = key(entry);
        return {
            ...acc,
            [k]: entry,
        };
    }, {});
}
exports.toRecord = toRecord;
